import { RootState } from '@beam-app/types';
import { addKnownStatus } from '@store/redux/features/inventory/knownData';
import { useAppDispatch } from '@store/redux/store';
import { pick } from '@utils/pick';
import { useSelector } from 'react-redux';
import { memo } from 'react';
import { EquipmentStatusSelector } from '../EquipmentStatusSelector';
import { InputDiv, InputList } from '../styles';
import { PropsInputSingle, FlattenSingle } from './types';
import { onChangeSingle } from './utils';

type StatusSingleProps = PropsInputSingle & FlattenSingle<'equipmentStatusId'>;
export function StatusSingle(props: StatusSingleProps) {
  const { onlyGroupEdits, index, setFormV, equipmentStatusId } = props;

  const statusIdName = `equipments.${index}.equipmentStatusId` as const;
  const dispatch = useAppDispatch();
  const knownStatuses = useSelector(
    (state: RootState) => state.knownData.knownStatuses,
  );
  const statusFilled = knownStatuses[equipmentStatusId ?? ''];
  return (
    <InputList>
      <InputDiv>
        <EquipmentStatusSelector
          equipmentStatus={statusFilled}
          onClickStatus={input => {
            dispatch(addKnownStatus(pick(input, ['name', 'id', 'category'])));
            onChangeSingle(statusIdName, input.id, setFormV);
          }}
          disabled={onlyGroupEdits}
        />
      </InputDiv>
    </InputList>
  );
}
export default memo(StatusSingle);
